module.exports = __webpack_public_path__ + "img/award1.f947e6fc.png";